<div class="d-flex flex-column">
	<label class="text-center text-tertiary fw-semibold w-100">
		{{ tituloTabela }}
	</label>

	<div style="max-width: 1300px">
		<div class="d-flex my-3 flex-row justify-content-end align-items-end gap-2">
			<!-- Ações à direita (mês de referência + personalizar colunas) -->
			<div class="d-flex align-items-end gap-2">
				<div
					*ngIf="isMensalAnualParcial"
					class="d-flex flex-column mes-referencia-wrapper">
					<label class="text-tertiary fw-semibold mb-1">
						Mês de referência
					</label>

					<input
						type="month"
						class="form-control form-control-sm"
						[formControl]="mesReferenciaMensalAnualControl"
						[attr.min]="mesReferenciaMin"
						[attr.max]="mesReferenciaMax" />
				</div>

				<seira-select-list-menu
					[opcoes]="opcoesColunas"
					[opcoesSelecionadas]="colunasSelecionadas"
					[disabled]="disabledSelectList || carregando"
					[tituloBotao]="'Personalizar colunas'"
					(atualizarOpcoesSelecionadas)="setColunasSelecionadas($event)">
				</seira-select-list-menu>
			</div>
		</div>
		<div
			*ngIf="carregando; else tabela"
			class="d-flex justify-content-center align-items-center w-100 h-50"
			style="min-height: 500px">
			<seira-loading [pageCentered]="false"></seira-loading>
		</div>

		<ng-template #tabela>
			<div style="max-width: 1300px" *ngIf="resultado?.length; else semDados">
				<div class="row mb-2">
					<seira-public-table
						#tabelaDesvioClimatologiaObservado
						id="tabelaDesvioClimatologiaObservado"
						[loading]="carregando"
						[searching]="false"
						[info]="false"
						[hasHeader]="false"
						[scrollX]="true"
						[columns]="colunas"
						[data]="resultado">
					</seira-public-table>
				</div>
			</div>
		</ng-template>

		<seira-card-info
			[texto]="texto"
			[aditionalClasses]="'w-100'"
			style="flex: 1">
		</seira-card-info>

		<ng-template #semDados>
			<seira-sem-dados></seira-sem-dados>
		</ng-template>
	</div>

	<ng-template #semDados>
		<seira-sem-dados></seira-sem-dados>
	</ng-template>
</div>
